var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Element 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,0a75,75,0,1,0,75,75A75,75,0,0,0,75,0Zm43.08,52.92a7.28,7.28,0,0,0-2.79,6.17,58.54,58.54,0,0,1-45.71,56.66c-14.84,3.25-32,.29-43.82-7.88,10.77,0,20.31-2.24,28.57-7.9-3.55-1.71-7.53-2.91-10.58-5.29S38.63,88.75,35.5,85l8,.48.58-.87C35.33,81,29.89,75,29.27,65l8.4,2.44C28.34,55,26.78,46.62,32.41,39.84,43.31,52.45,56.93,59.77,74,61a29.25,29.25,0,0,0,0-3c-1-8.81,2.67-15.45,10-19.89s15.14-4.52,21.9.55c4.08,3.06,7.27,2.56,11.1.82,1.6-.72,3.17-1.51,4.75-2.27l.82.69-7.21,9.69L125.48,45C122.63,48.12,120.59,50.79,118.08,52.92Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.ee3b941a1fd5561d7d9d30b2cfcface1.svg";
export { ForwardRef as ReactComponent };